'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'fan';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f863';
var svgPathData = ['M50.4 240c11.1 54.8 59.5 96 117.6 96 14.1 0 27.5-2.4 40-6.8 7.3-2.6 15.5-1.5 21.9 3S240 344 240 351.8l0 109.8c54.8-11.1 96-59.5 96-117.6 0-14.1-2.4-27.5-6.8-40-2.6-7.3-1.5-15.5 3-21.9S344 272 351.8 272l109.8 0c-11.1-54.8-59.5-96-117.6-96-14.1 0-27.5 2.4-40 6.8-7.3 2.6-15.5 1.5-21.9-3S272 168 272 160.2l0-109.8c-54.8 11.1-96 59.5-96 117.6 0 14.1 2.4 27.5 6.8 40 2.6 7.3 1.5 15.5-3 21.9S168 240 160.2 240L50.4 240zM288 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z', 'M176 168c0-58.1 41.2-106.5 96-117.6l0 109.8c0 7.8 3.8 15.1 10.1 19.6s14.5 5.6 21.9 3c12.5-4.4 25.9-6.8 40-6.8 58.1 0 106.5 41.2 117.6 96l-109.8 0c-7.8 0-15.1 3.8-19.6 10.1s-5.6 14.5-3 21.9c4.4 12.5 6.8 25.9 6.8 40 0 58.1-41.2 106.5-96 117.6l0-109.8c0-7.8-3.8-15.1-10.1-19.6s-14.5-5.6-21.9-3c-12.5 4.4-25.9 6.8-40 6.8-58.1 0-106.5-41.2-117.6-96l109.8 0c7.8 0 15.1-3.8 19.6-10.1s5.6-14.5 3-21.9c-4.4-12.5-6.8-25.9-6.8-40zM296 0c-92.8 0-168 75.2-168 168 0 8.1 .6 16.2 1.7 24L24 192c-13.3 0-24 10.7-24 24 0 92.8 75.2 168 168 168 8.1 0 16.2-.6 24-1.7L192 488c0 13.3 10.7 24 24 24 92.8 0 168-75.2 168-168 0-8.1-.6-16.2-1.7-24L488 320c13.3 0 24-10.7 24-24 0-92.8-75.2-168-168-168-8.1 0-16.2 .6-24 1.7L320 24c0-13.3-10.7-24-24-24zM256 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFan = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;